"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeFutureDateFromSeconds = exports.dateAsIsoString = exports.disassemblyDateForIndex = exports.getEndDate = exports.extractDuration = exports.build = exports.disassemblyDate = exports.enumerateDates = exports.getDayBefore = exports.getDelayInSecond = exports.convertToDate = exports.canBeTriggerInTheNextFifteenMinutes = exports.canBeTriggerimmediately = exports.getTimestamp = exports.getDateFromTimestamp = exports.getNextFifteenMinutesTimestamp = exports.getNextWeekDate = exports.getNextMonthTimestamp = exports.getNextYearTimestamp = exports.getNextWeekTimestamp = exports.getNextDayTimestamp = exports.isInThePast = exports.isNearOf = exports.isNear = exports.getSafeTargetDate = exports.getSafeTargetQuarter = exports.getTargetQuarter = exports.getNowPastTenMinutes = exports.getNowPastFiveMinutes = exports.getLatestQuarterFromTimestamp = exports.getLatestQuarter = exports.getNextHour = exports.isInCurrentQuarter = exports.isInNextQuarter = exports.getNextSafeQuarter = exports.getNextQuarter = exports.getCurrentQuarter = void 0;
const moment_1 = __importDefault(require("moment"));
const smash_logger_1 = require("smash-logger");
const smash_type_1 = require("smash-type");
const constant_1 = require("./constant");
__exportStar(require("./constant"), exports);
const logger = new smash_logger_1.Logger();
function getCurrentQuarter() {
    return getTargetQuarter(new Date().toISOString());
}
exports.getCurrentQuarter = getCurrentQuarter;
function getNextQuarter() {
    return getTargetQuarter(new Date().toISOString()) + constant_1.FITEEN_MINUTES_S;
}
exports.getNextQuarter = getNextQuarter;
function getNextSafeQuarter() {
    return getTargetQuarter(new Date().toISOString()) + (2 * constant_1.FITEEN_MINUTES_S);
}
exports.getNextSafeQuarter = getNextSafeQuarter;
function isInNextQuarter(date) {
    return getTargetQuarter(date) === getNextQuarter();
}
exports.isInNextQuarter = isInNextQuarter;
function isInCurrentQuarter(date) {
    return getTargetQuarter(date) === getCurrentQuarter();
}
exports.isInCurrentQuarter = isInCurrentQuarter;
function getNextHour() {
    return getTargetQuarter(new Date().toISOString()) + (4 * constant_1.FITEEN_MINUTES_S);
}
exports.getNextHour = getNextHour;
function getLatestQuarter(date = new Date()) {
    return getTargetQuarter(date) - constant_1.FITEEN_MINUTES_S;
}
exports.getLatestQuarter = getLatestQuarter;
function getLatestQuarterFromTimestamp(timestamp) {
    logger.deprecated("getLatestQuarterFromTimestamp() is deprecated. Use getLatestQuarter() instead");
    return getTargetQuarter(timestamp) - constant_1.FITEEN_MINUTES_S;
}
exports.getLatestQuarterFromTimestamp = getLatestQuarterFromTimestamp;
function getNowPastFiveMinutes() {
    return new Date(new Date().getTime() + constant_1.FIVE_MINUTES_S * constant_1.FACTOR);
}
exports.getNowPastFiveMinutes = getNowPastFiveMinutes;
function getNowPastTenMinutes() {
    return new Date(new Date().getTime() + constant_1.TEN_MINUTES_S * constant_1.FACTOR);
}
exports.getNowPastTenMinutes = getNowPastTenMinutes;
function getTargetQuarter(date) {
    const target = build(date).toDate();
    const minutes = target.getMinutes() - (target.getMinutes() % constant_1.FITEEN_MINUTES_M);
    target.setMinutes(minutes, 0, 0);
    return target.getTime() / constant_1.FACTOR;
}
exports.getTargetQuarter = getTargetQuarter;
function getSafeTargetQuarter(date) {
    const safe = getNextSafeQuarter();
    const target = getTargetQuarter(date);
    if (target < safe) {
        return safe;
    }
    return target;
}
exports.getSafeTargetQuarter = getSafeTargetQuarter;
function getSafeTargetDate(date) {
    const safe = getNextSafeQuarter();
    const target = getTargetQuarter(date);
    if (target < safe) {
        return new Date(safe * constant_1.FACTOR).toISOString();
    }
    return new Date(target * constant_1.FACTOR).toISOString();
}
exports.getSafeTargetDate = getSafeTargetDate;
function isNear(date, second) {
    if (!date) {
        return false;
    }
    const dateToCompare = build(date).toDate().getTime();
    const before = new Date(new Date().getTime() - (second * constant_1.FACTOR)).getTime();
    const after = new Date(new Date().getTime() + (second * constant_1.FACTOR)).getTime();
    return before <= dateToCompare && dateToCompare <= after;
}
exports.isNear = isNear;
function isNearOf(date, second, target) {
    if (!date || !target) {
        return false;
    }
    const dateToCompare = build(date).toDate().getTime();
    const before = new Date(build(target).toDate().getTime() - (second * constant_1.FACTOR)).getTime();
    const after = new Date(build(target).toDate().getTime() + (second * constant_1.FACTOR)).getTime();
    return before <= dateToCompare && dateToCompare <= after;
}
exports.isNearOf = isNearOf;
function isInThePast(date) {
    if (!date) {
        return false;
    }
    return getTimestamp(date) < getTimestamp();
}
exports.isInThePast = isInThePast;
function getNextDayTimestamp() {
    return getTimestamp() + constant_1.ONE_DAY_S;
}
exports.getNextDayTimestamp = getNextDayTimestamp;
function getNextWeekTimestamp() {
    return getTimestamp() + constant_1.ONE_WEEK_S;
}
exports.getNextWeekTimestamp = getNextWeekTimestamp;
function getNextYearTimestamp() {
    return getTimestamp(moment_1.default.utc().add(1, "y"));
}
exports.getNextYearTimestamp = getNextYearTimestamp;
function getNextMonthTimestamp() {
    return getTimestamp(moment_1.default.utc().add(1, "M"));
}
exports.getNextMonthTimestamp = getNextMonthTimestamp;
function getNextWeekDate() {
    return new Date(getNextWeekTimestamp() * constant_1.FACTOR).toISOString();
}
exports.getNextWeekDate = getNextWeekDate;
function getNextFifteenMinutesTimestamp() {
    return getTimestamp() + constant_1.FITEEN_MINUTES_S;
}
exports.getNextFifteenMinutesTimestamp = getNextFifteenMinutesTimestamp;
function getDateFromTimestamp(timestamp) {
    logger.deprecated("getDateFromTimestamp() is deprecated. Use convertToDate() instead");
    return new Date(timestamp * constant_1.FACTOR);
}
exports.getDateFromTimestamp = getDateFromTimestamp;
function getTimestamp(date = new Date()) {
    return Math.floor(build(date).toDate().getTime() / constant_1.FACTOR);
}
exports.getTimestamp = getTimestamp;
function canBeTriggerimmediately(date) {
    return getTimestamp(date) <= getTimestamp();
}
exports.canBeTriggerimmediately = canBeTriggerimmediately;
function canBeTriggerInTheNextFifteenMinutes(date) {
    return getTimestamp(date) < getNextFifteenMinutesTimestamp();
}
exports.canBeTriggerInTheNextFifteenMinutes = canBeTriggerInTheNextFifteenMinutes;
function convertToDate(date) {
    return build(date).toDate();
}
exports.convertToDate = convertToDate;
function getDelayInSecond(date) {
    const delay = getTimestamp(date) - getTimestamp();
    return delay >= 0 ? delay : 0;
}
exports.getDelayInSecond = getDelayInSecond;
function getDayBefore(date) {
    return getTimestamp(date) - constant_1.ONE_DAY_S;
}
exports.getDayBefore = getDayBefore;
function enumerateDates(startDate, endDate, unit, format) {
    if (Object.values(constant_1.units).indexOf(unit) < 0) {
        unit = constant_1.units.days;
    }
    const dates = [];
    const currentDate = build(startDate).startOf(constant_1.START_OF_UNITS[unit]);
    const lastDate = build(endDate).startOf(constant_1.START_OF_UNITS[unit]);
    while (currentDate.diff(lastDate) <= 0) {
        dates.push(format ? currentDate.format(format) : currentDate.toISOString());
        currentDate.add(1, unit);
    }
    return dates;
}
exports.enumerateDates = enumerateDates;
function disassemblyDate(date = new Date()) {
    const parsedDate = build(date);
    const year = parsedDate.year();
    const month = parsedDate.month() + 1;
    const day = parsedDate.date();
    const hour = parsedDate.hour();
    const minute = parsedDate.minute();
    const second = parsedDate.second();
    return { year, month, day, hour, minute, second };
}
exports.disassemblyDate = disassemblyDate;
function build(date) {
    if (typeof date === 'number') {
        if (date.toString().length >= new Date().getTime().toString().length) {
            return moment_1.default.utc(date);
        }
        return moment_1.default.unix(date).utc();
    }
    else {
        return moment_1.default.utc(date);
    }
}
exports.build = build;
function extractDuration(duration) {
    const regexpDuration = /^([0-9]+)\s?(hour|hours|day|days|week|weeks|month|months|year|years)$/;
    try {
        const [, quantity, unit] = duration.match(regexpDuration);
        return { quantity: parseInt(quantity), unit };
    }
    catch (error) {
        throw new Error("Invalid duration given " + duration);
    }
}
exports.extractDuration = extractDuration;
function getEndDate({ start, quantity, unit }) {
    return build(start).add(quantity, unit).toISOString();
}
exports.getEndDate = getEndDate;
function disassemblyDateForIndex(date = new Date()) {
    const { year, month, day, hour } = disassemblyDate(date);
    return {
        year: year.toString(),
        month: month.toString(),
        yearMonthDay: year.toString() + smash_type_1.separator + month.toString() + smash_type_1.separator + day.toString(),
        day: day.toString(),
        hour: hour.toString(),
    };
}
exports.disassemblyDateForIndex = disassemblyDateForIndex;
function dateAsIsoString(date = new Date()) {
    return build(date).toISOString();
}
exports.dateAsIsoString = dateAsIsoString;
function computeFutureDateFromSeconds(secondsToAdd, date = (0, moment_1.default)()) {
    return (0, moment_1.default)(date).add(secondsToAdd, 'seconds').toISOString();
}
exports.computeFutureDateFromSeconds = computeFutureDateFromSeconds;
